import App from './App.svelte';

const app = new App({
    target: document.getElementById("woo-variations-table-component"),
    props: {
        variations: wooVariationsTableData.variations,
        attributes: wooVariationsTableData.attributes,
        showFilters: wooVariationsTableData.showFilters,
        activeColumns: wooVariationsTableData.activeColumns,
        columnsOrder: wooVariationsTableData.columnsOrder,
        imageURL: wooVariationsTableData.imageURL,
        showSpinner: wooVariationsTableData.showSpinner,
        textVars: wooVariationsTableData.textVars,
        showAddToCart: wooVariationsTableData.showAddToCart,
        showAddToEnquiry: wooVariationsTableData.showAddToEnquiry,
        layoutType: wooVariationsTableData.layoutType,
        defaultInputQty: wooVariationsTableData.defaultInputQty,
        CewB2B: wooVariationsTableData.CewB2B,
        multiAddNonce: wooVariationsTableData.multiAddNonce
    }
});

export default app;
